/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import type { AssetDtoType } from './assetDtoType';

export interface AssetDto {
  /** Asset ID */
  id: string;
  /** Asset file name */
  fileName: string;
  /** Asset name */
  name: string;
  /** Asset type. By default: `supportingDocument` */
  type?: AssetDtoType;
  /** Created at */
  createdAt: string;
  /** Updated at */
  updatedAt: string;
}
